import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../lib/axios";

// Fetch Phone Number Health (Quality Rating, Messaging Limit, Name Status)
export const fetchPhoneNumberHealth = createAsyncThunk(
  "whatsapp/fetchHealth",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/api/whatsapp/health/${projectId}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);
